export const NOTIFICATION_TYPES = {
  WARNING: 'warningNotification' as const,
  ERROR: 'errorNotification' as const,
  SUCCESS: 'successNotification' as const,
  INFO: 'infoNotification' as const
};

export type NOTIFICATION_TYPES = typeof NOTIFICATION_TYPES[keyof typeof NOTIFICATION_TYPES];